//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'UnTabsUiVerticalUpdate',
  props: {
    tabClass: {
      type: String,
      default: 'tabs',
    },
  },

  data() {
    return {
      tabs: [],
    }
  },

  mounted() {
    // eslint-disable-next-line
    this.tabs = this.$children.filter(child => child.$options.name === 'UnTabUi')
    const defaultTab = this.tabs.find(tab => tab.selected) || this.tabs[0]
    if (defaultTab) {
      this.selectTab(defaultTab)
    }
  },

  methods: {
    selectTab(selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = (tab.name === selectedTab.name)
      })
    },
  },
}
